import React, { createContext, useContext, useMemo, useState } from 'react';
import { isBefore } from 'date-fns';
//interfaces
import { IPreOrders } from 'pages/Quotes/components/Dropdown/PortalOrderDropdown/interface';
import { DetailsQuoteContextProviderProps, DetailsQuoteContextType } from './interface';
import { PortalOrder } from 'models/portalModels/PortalOrder';
import { IQuoteDetailItem } from 'models/QuoteDetailItem';
import { IBatchRequestResponse } from 'models/Batch';
import { IQuoteDetail } from 'models/QuoteDetail';

export const DetailsQuoteContext = createContext({} as DetailsQuoteContextType);

export function DetailsQuoteContextProvider(props: Readonly<DetailsQuoteContextProviderProps>) {
  const { children } = props;
  const [preOrderDetails, setPreOrderDetails] = useState<IPreOrders[] | undefined>(undefined);
  const [quoteItem, setQuoteItem] = useState<IBatchRequestResponse<IQuoteDetailItem>>();
  const [secondDetailPageRender, setSecondDetailPageRender] = useState<boolean>(false);
  const [order, setOrder] = useState<IBatchRequestResponse<PortalOrder>>(Object());
  const [showPriceHistoryModal, setShowPriceHistoryModal] = useState(false);
  const [modalPaymentTermModal, setModalPaymentTermModal] = useState(false);
  const [renderAgainMoney, setRenderAgainMoney] = useState<boolean>(false);
  const [finishUpdateOrder, setFinishUpdateOrder] = useState(false);
  const [quoteDetail, setQuoteDetail] = useState<IQuoteDetail>();
  const [itemPriceHistory, setItemPriceHistory] = useState();
  const [updateChecked, setUpdateChecked] = useState(false);
  const [sequenceNumber, setSequenceNumber] = useState("");
  const [firstLoadPage, setFirstLoadPage] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [useMoney, setUseMoney] = useState(false);
  const [sequence, setSequence] = useState(0);

  const resetItemPriceHistory = () => {
    setShowPriceHistoryModal(false);
    setItemPriceHistory(undefined);
    setSequenceNumber("");
    setSequence(0);
  };

  const isQuoteExpired = useMemo(() => (quoteDetail ? isBefore(new Date(quoteDetail.expiresAt!), new Date()) : true), [quoteDetail]);

  return (
    <DetailsQuoteContext.Provider value={{
      order,
      setOrder,
      sequence,
      useMoney,
      quoteItem,
      setSequence,
      quoteDetail,
      currentPage,
      setUseMoney,
      setQuoteItem,
      firstLoadPage,
      updateChecked,
      isQuoteExpired,
      sequenceNumber,
      setCurrentPage,
      setQuoteDetail,
      preOrderDetails,
      itemPriceHistory,
      renderAgainMoney,
      setFirstLoadPage,
      setUpdateChecked,
      finishUpdateOrder,
      setSequenceNumber,
      setPreOrderDetails,
      setItemPriceHistory,
      setRenderAgainMoney,
      setFinishUpdateOrder,
      resetItemPriceHistory,
      showPriceHistoryModal,
      modalPaymentTermModal,
      secondDetailPageRender,
      setShowPriceHistoryModal,
      setModalPaymentTermModal,
      setSecondDetailPageRender,
    }}>
      {children}
    </DetailsQuoteContext.Provider>
  );
}

export const useDetailsQuoteContext = () => {
  return useContext(DetailsQuoteContext);
};